// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qo0L","colBig":"styles_colBig__gYnRQ","colSmall":"styles_colSmall__3f3Ru"};